// extracted by mini-css-extract-plugin
export default {"fullWidth":"mo-z","image":"no-z","lazyLoadPicture":"oo-z","lazyLoadSpinner":"po-z","lazyLoadSpin":"qo-z","lazyLoadImage":"ro-z","hasStyledAspectRatio":"so-z"};